import { HugeiconsIcon } from '@hugeicons/react'
import { Add01Icon } from '@hugeicons/core-free-icons'

import { useInviteDirectReport } from '../services'
import { InviteDirectReportFormContent } from './invite-form-fields'

import type { InviteDirectReportResponse } from '../types/direct-report.types'
import type { InviteFormData } from './invite-form-fields'
import { Button } from '@/components/ui/button'
import { useFormDialog } from '@/contexts/form-dialog-context'
import { useMyConvexUserId } from '@/features/auth'

interface InviteDirectReportButtonProps {
  children?: React.ReactNode
  onSuccess?: (data: InviteDirectReportResponse) => void
}

export const InviteDirectReportButton = ({
  children,
  onSuccess,
}: InviteDirectReportButtonProps) => {
  const { showFormDialog } = useFormDialog()
  const inviteDirectReportMutation = useInviteDirectReport()
  const currentUserId = useMyConvexUserId()

  const handleSubmit = async (data: InviteFormData) => {
    return await inviteDirectReportMutation.mutateAsync({
      email: data.email,
      managerId: data.managerId,
      positionId: data.positionId,
      roles: data.roles,
      path: data.path,
    })
  }

  const handleCreateClick = () => {
    showFormDialog<InviteFormData, InviteDirectReportResponse>({
      title: 'Invite Direct Report',
      description: 'Invite a new direct report to the organization',
      submitText: 'Send Invite',
      showSuccessState: false,
      formOptions: {
        defaultValues: {
          email: '',
          managerId: currentUserId || '',
          positionRole: '',
          positionLevel: '',
          positionId: '',
          roles: [],
          path: '',
        },
      },
      children: (form) => <InviteDirectReportFormContent form={form} />,
      onSubmit: handleSubmit,
      onSuccess,
    })
  }

  return (
    <Button onClick={handleCreateClick}>
      {children || (
        <>
          <HugeiconsIcon icon={Add01Icon} className="mr-2 h-4 w-4" />
          Invite Direct Report
        </>
      )}
    </Button>
  )
}
